import { ActionRegistryCategory } from '../../../registry/action/ActionRegistryCategory';
import { ActionsAssociate } from '../../../questiontype/Associate/registry/ActionsAssociate';
import { ActionsMultiSelect } from '../../../questiontype/MultiSelect/registry/ActionsMultiSelect';
export class RareActions extends ActionRegistryCategory {
    label = 'Rare';
    constructor(parent) {
        super(parent);
    }
    c_a = new ActionsAssociate(this);
    c_m = new ActionsMultiSelect(this);
}
